import { Ng2StateDeclaration, StateRegistry } from '@uirouter/angular';
import { GeographicalSummaryPageComponent } from './feature/geographical-summary-page/geographical-summary-page.component';

export const geographicalSummaryStateAngular: Ng2StateDeclaration = {
    parent: 'app',
    name: 'geographicalSummary',
    url: '/geographicalSummary?sectorId&regionId&countryId&projectID&projectName',
    params: {
        sectorId: {
            value: null,
            squash: true,
            dynamic: true,
        },
        regionId: {
            value: null,
            squash: true,
            dynamic: true,
        },
        countryId: {
            value: null,
            squash: true,
            dynamic: true,
        },
        projectID: {
            value: null,
            squash: true,
            dynamic: true,
        },
        projectName: {
            value: null,
            squash: true,
            dynamic: true,
        }
    },
    component: GeographicalSummaryPageComponent,
    data: { requiresAuth: true }
};

export function registerGeographicalSummaryStates(
    registry: StateRegistry,
    config: { enableNewGeographicalSummary: boolean }
): void {
    if (!config.enableNewGeographicalSummary) {
        return;
    }

    if (!registry.get(geographicalSummaryStateAngular.name)) {
        registry.register(geographicalSummaryStateAngular);
    }
}
